import type { FC, ReactElement, ReactNode, SyntheticEvent } from 'react';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import type { AffSub4 } from '@src/@types/microcredits';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { FreeButton } from '@src/components/FreeButton';

interface Props {
  offer: IClientMicrocreditListItem;
  actionButton: ReactNode;
  freeButtonLink: string;
  affSub4: AffSub4;
  source: string;
  className: string;
  visibleLabel?: string;
  onClick: (event: SyntheticEvent<Element, Event>) => void;
}

export const CardActionButton: FC<Props> = ({ offer, freeButtonLink, className, onClick, ...advertisingBtnProps }) => {
  const { advertising } = offer;

  if (advertising) {
    return (
      <AdvertisingButton
        advSub={advertising.advSub}
        analytics={offer}
        className={className}
        onClick={onClick}
        {...advertisingBtnProps}
      />
    );
  }

  return <FreeButton analytics={offer} link={freeButtonLink} className={className} onClick={onClick} />;
};
